const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const

/**
 * Build a human-readable label for a royalty report period.
 *
 * @param periodYear - The year of the reporting period (e.g. 2025)
 * @param periodMonth - The month of the reporting period (1–12)
 * @returns A label like `January 2025 Royalty`
 *
 * @example
 * royaltyLabel(2025, 1)  // 'January 2025 Royalty'
 * royaltyLabel(2024, 12) // 'December 2024 Royalty'
 */
export function royaltyLabel(periodYear: number, periodMonth: number): string {
  const monthName = MONTH_NAMES[periodMonth - 1] ?? 'Unknown'
  return `${monthName} ${periodYear} Royalty`
}
